import React, { useState, useRef } from 'react';
import { pexios } from '../../utils/functions';
import Modal from './Modal';
import SignatureCanvas from 'react-signature-canvas';

const dimensions = {
    width: window.outerWidth,
    height: window.outerHeight,
};

export default function Signature({ open, close, name, reportId }) {

    const [loader, setLoader] = useState(false);

    let signCanvas = useRef(null);

    function clear() {
        signCanvas.clear();
    }
    function cancel() {
        clear();
        close();
    }
    function trim(){
        setLoader(true);
        let fd = new FormData();
        fd.append('id', reportId);
        fd.append('name', name);
        fd.append(name, DataURIToBlob(signCanvas.toDataURL()) );
        pexios('api/upload_sign','post',fd,true).then(res=>{
            close(res.data)
        });
    }
    function DataURIToBlob(dataURI) {
        const splitDataURI = dataURI.split(',');
        const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1]);
        const mimeString = splitDataURI[0].split(':')[1].split(';')[0];

        const ia = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++)
            ia[i] = byteString.charCodeAt(i);

        return new Blob([ia], { type: mimeString })
    }

    return (
        <Modal visible={open}>
            <div className='signature'>
                <div className='p10 text-justify' dir='rtl'>
                    با سپاس از همکاری شما. لطفا جهت ادامه پیگیری پرونده با استفاده از انگشت خود در بخش سفید رنگ امضا نمایید.
                </div>
                <SignatureCanvas ref={ref => signCanvas = ref} canvasProps={{width: dimensions.width, height: dimensions.height}} />
                <div className='buttonParent'>
                    <button className='btn btn-green btn-block' onClick={trim} disabled={loader && 'disabled'}>
                        {
                            loader ?
                                <i className='fas fa-spinner fa-spin'/> :
                                'ذخیره'

                        }
                    </button>
                    <button className='btn btn-yellow btn-block' onClick={clear}>دوباره</button>
                    <button className='btn btn-red btn-block' onClick={cancel}>خروج</button>
                </div>
            </div>
        </Modal>
    );

}
